<template>
  <div class="couponList">
    <ul class="listBox" v-if="type == 1">
      <li class="item" v-for="(item, index) in listCoupon" :key="index">
        <van-row type="flex" align="center" class="infoBox">
          <van-col class="infoBoxLeft">
            <div class="amount">
              <span class="symbol">¥</span>{{ item.DiscountAmount }}
            </div>
            <div class="amount-right">
              <div class="condition" v-if="!item.IsNoThreshold">
                {{ $t.couponInterpret.condition(item.UseCondition) }} (
                {{ $t.couponInterpret.maxCount(item.B_MaxCount - item.ShopCouponCount) }}
                )
              </div>
              <div class="condition" v-else>
                {{ $t.couponInterpret.noCondition }} (
                {{ $t.couponInterpret.maxCount(item.B_MaxCount - item.ShopCouponCount) }}
                )
              </div>
            </div>
          </van-col>
          <van-col class="infoBoxRigth">
            <van-button
              class="doneBtn"
              v-if="item.ShopCouponCount == item.B_MaxCount"
              disabled
            >
              {{ $t.couponInterpret.state5 }}
            </van-button>
            <van-button class="getBtn" v-else @click="addShopCoupon(item.ACId)">
              {{ $t.couponInterpret.addCoupon }}
            </van-button>
          </van-col>
        </van-row>
      </li>
    </ul>

    <ul class="listBox" v-if="type == 2">
      <li class="item" v-for="(parent, pIdx) in listCoupon" :key="pIdx">
        <van-collapse v-for="(child, cIdx) in parent" :key="cIdx" v-model="activeNames">
          <van-collapse-item
            :title="$t.couponInterpret.couponCount(Object.keys(parent).toString())"
            :name="pIdx"
          >
            <van-row
              type="flex"
              align="center"
              class="couponBox"
              v-for="(item, idx) in child"
              :key="idx"
            >
              <van-col class="couponBoxLeft">
                <div class="amount">
                  <span class="symbol">¥</span>{{ item.DiscountAmount }}
                </div>
                <div class="amount-right">
                  <div class="condition" v-if="!item.IsNoThreshold">
                    {{ $t.couponInterpret.condition(item.UseCondition) }}
                  </div>
                  <div class="condition" v-else>
                    {{ $t.couponInterpret.noCondition }}
                  </div>
                  <div class="date">
                    {{ $t.couponInterpret.endDate }} : {{ item.MaturityTime }}
                  </div>
                </div>
              </van-col>
              <van-col class="couponBoxRigth">
                <van-button class="useBtn" @click="actionFansSelection(item.BCId)">
                  {{ $t.couponInterpret.goShare }}
                </van-button>
              </van-col>
            </van-row>
          </van-collapse-item>
        </van-collapse>
      </li>
    </ul>

    <ul class="listBox" v-if="type == 3 || type == 4">
      <li class="item" v-for="(item, index) in listCoupon" :key="index">
        <van-row type="flex" align="center" class="usedBox">
          <van-col class="usedBoxLeft">
            <div class="amount">
              <span class="symbol">¥</span>{{ item.DiscountAmount }}
            </div>
            <div class="amount-right">
              <div class="condition" v-if="!item.IsNoThreshold">
                {{ $t.couponInterpret.condition(item.UseCondition) }}
              </div>
              <div class="condition" v-else>
                {{ $t.couponInterpret.noCondition }}
              </div>
              <div class="date" v-if="type == 3">
                {{ item.HasShareDate }} {{ $t.couponInterpret.state6 }}
              </div>
              <div class="date" v-if="type == 4">
                {{ item.MaturityTime }} {{ $t.couponInterpret.state4 }}
              </div>
              <div class="shareTo" v-if="type == 3">
                {{ $t.couponInterpret.shareTo }} : {{ item.UserName }}
              </div>
            </div>
          </van-col>
          <van-col class="usedBoxRigth">
            <div class="usedTxt" v-if="type == 3">
              {{ $t.couponInterpret.state3 }}
            </div>
            <div class="usedTxt" v-if="type == 4">
              {{ $t.couponInterpret.state4 }}
            </div>
          </van-col>
        </van-row>
      </li>
    </ul>
  </div>
</template>
<script>
import Vue from "vue";
import { Button, Image, Icon, Row, Col, Collapse, CollapseItem } from "vant";
Vue.use(Button).use(Row).use(Col).use(Image).use(Icon).use(Collapse).use(CollapseItem);

import Selection from "@view/store/coupon/index.js";

export default {
  name: "CouponList",
  props: ["listCoupon", "type"],
  components: {},
  data() {
    return {
      activeNames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    };
  },
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value.split("|")[0]);
    },
    addShopCoupon(id) {
      this.$emit("addShopCoupon", id);
    },
    actionFansSelection(id) {
      const selection = Selection({
        id: id,
      });
      selection.onSelected = (data) => {
        this.$emit("shareShopCoupon", {
          BCId: id,
          UserId: data.UserId,
        });
      };
      selection.show();
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin puiblicFlex {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
@mixin publicBt {
  cursor: pointer;
  -webkit-cursor: pointer;
  border-radius: 32px;
  padding: 12px 0;
  text-align: center;
}
.van-collapse {
  ::v-deep .van-collapse-item__content {
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    padding-bottom: 20px;
  }
}
.couponList {
  width: 100%;
  .listBox {
    margin: 0% 3%;
    .item {
      padding: 15px;
      border-radius: 10px;
      background-color: #ffffff;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      margin-top: 15px;
      line-height: 50px;
      .itemTop {
        .itemTopTitle {
          width: 77%;
          font-size: 24px;
          flex: 1;
          -webkit-flex: 1;
          color: #000000;
          font-weight: bold;
        }
        .shelves {
          border: 1px solid #999999;
          width: 110px;
          text-align: center;
          border-radius: 32px;
          padding: 12px 0;
          color: #999999;
        }
        .putaway {
          border: 1px solid #ff625c;
          width: 110px;
          text-align: center;
          border-radius: 32px;
          padding: 15px 0;
          color: #ff625c;
        }
      }
    }
  }
  .infoBox {
    .infoBoxLeft {
      width: 77%;
      padding-right: 2.5%;
      margin-right: 2.5%;
      text-align: left;
      border-right: 2px dotted #0090e6;
      .amount {
        color: #0090e6;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        width: 30%;
        display: inline-block;
        vertical-align: middle;
        .symbol {
          font-size: 14px;
          margin-right: 5px;
        }
      }
      .amount-right {
        width: 70%;
        display: inline-block;
        vertical-align: middle;
        .condition {
          color: #999;
          font-size: 12px;
          line-height: 2;
        }
      }
    }
    .infoBoxRigth {
      width: 20%;
      text-align: center;
      .doneBtn {
        font-weight: bold;
        border: none;
        padding: 0;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .getBtn {
        color: #0090e6;
        font-weight: bold;
        border: none;
        padding: 0;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
    }
  }
  .usedBox {
    .usedBoxLeft {
      width: 77%;
      padding-right: 2.5%;
      margin-right: 2.5%;
      text-align: left;
      border-right: 2px dotted #999;
      .amount {
        color: #999;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        width: 30%;
        display: inline-block;
        vertical-align: middle;
        .symbol {
          font-size: 14px;
          margin-right: 5px;
        }
      }
      .amount-right {
        width: 70%;
        display: inline-block;
        vertical-align: middle;
        .condition {
          color: #999;
          font-size: 12px;
          line-height: 2;
        }
        .date {
          color: #999;
          font-size: 12px;
          line-height: 2;
        }
        .shareTo {
          color: #999;
          font-size: 10px;
          line-height: 2;
        }
      }
    }
    .usedBoxRigth {
      width: 20%;
      text-align: center;
      .usedTxt {
        color: #999;
        font-weight: bold;
        vertical-align: middle;
        font-size: 14px;
      }
    }
  }
  .couponBox {
    margin-top: 20px;
    .couponBoxLeft {
      width: 75%;
      text-align: left;
      .amount {
        color: #0090e6;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        width: 30%;
        display: inline-block;
        vertical-align: middle;
        .symbol {
          font-size: 14px;
          margin-right: 5px;
        }
      }
      .amount-right {
        width: 70%;
        display: inline-block;
        vertical-align: middle;
        .condition {
          color: #999;
          font-size: 12px;
          line-height: 2;
        }
        .date {
          color: #999;
          font-size: 12px;
          line-height: 2;
        }
      }
    }
    .couponBoxRigth {
      width: 25%;
      text-align: center;
      .useBtn {
        color: #0090e6;
        border: 1px solid #0090e6;
        border-radius: 20px;
        padding: 5px 10px;
        line-height: unset;
        height: auto;
        .van-button__text {
          font-size: 12px !important;
        }
      }
    }
  }
}
</style>
